import { decryptData, encryptData } from "../utils/encrypt";
import { Urls } from "./Urls";
import services from "./services";

export const callautopopulate = async (...keys) => {
  if (!Array.isArray(keys)) {
    console.error("must be an array of keys.");
    return null;
  }
  const results = {};
  const keysToFetch = keys.filter(key => sessionStorage.getItem(key) === null || sessionStorage.getItem(key) === undefined);

  if (keysToFetch.length > 0) {
    try {
      const payload = {
        key_list: keysToFetch.toString(),
      };
      const res = await services.getInvokeRemote('POST', Urls('GETAUTOPOPULATESUMMARY'), payload);
      if (res && res.body && res.body.data) {
        const decryptDataResult = res.body.data 
        for (const key of keysToFetch) {
          if (decryptDataResult[key]) {
            const response = decryptDataResult[key];
            const encryptedRes = encryptData(response);
            sessionStorage.setItem(key, encryptedRes);
            results[key] = await decryptData(encryptedRes);
          } else {
            results[key] = null;
          }
        }
      } else {
        console.error("err:", res);
        keysToFetch.forEach(key => results[key] = null);
      }

    } catch (err) {
      console.error("err:", err);
      keysToFetch.forEach(key => results[key] = null);
    }
  }
  for (const key of keys) {
    if (!results[key]) {
      const encryptedRes = sessionStorage.getItem(key);
      if (encryptedRes) {
        results[key] = await decryptData(encryptedRes);
      } else {
        results[key] = null;
      }
    }
  }
  return results;

};
